{
  "element_add_emoji": "Добавить эмодзи",
  "add_comment_to_your_answer": "Добавить комментарий к вашему ответу",
  "ai_feature_description": "ИИ анализирует ответы и формирует ключевые выводы",
  "ai_feature_title": "Опросы ИИ",
  "ai_summary_open_answer_description": "Главные мысли из ответов",
  "all_set_and_ready_description": "Приглашения будут отправлены, пользователи начнут отвечать.",
  "all_set_and_ready_schedule_description": "Приглашения будут отправлены по расписанию.",
  "all_set_and_ready_schedule_title": "Все готово к запуску.\nЗапустить позже по расписанию?",
  "all_set_and_ready_title": "Всё готово к запуску.\nНачнем ваш опрос прямо сейчас?",
  "allow_multiple_selection": "Разрешить множественный выбор",
  "allow_other_option": "Разрешить другой вариант",
  "anonymous_file_warning_description": "Имя или содержимое файла может раскрыть личность респондента. Проверьте вопросы с файлами перед запуском анонимного опроса.",
  "anonymous_file_warning_title": "Файлы могут нарушить анонимность",
  "anonymous_participated": "Анонимное участие",
  "anonymous_threshold": "Количество ответов для раскрытия результатов",
  "anonymous_threshold_min_value": "Минимальное значение 3",
  "answer": "Ответ",
  "answer_anonymously": "Ответить анонимно",
  "answers_breakdown": "Данные ответов",
  "app_notification_title": "Примите участие в опросе",
  "complete_survey": "Завершить опрос",
  "complete_survey_confirm": "После завершения вы получите финальную статистику, а сотрудники больше не смогут участвовать в опросе.",
  "complete_survey_question": "Вы хотите завершить опрос?",
  "create_scale": "Создать шкалу",
  "create_survey": "Создать опрос",
  "create_survey_template": "Создать шаблон опроса",
  "create_template": "Создать шаблон",
  "delete_from_item_question": "Вы хотите удалить этот элемент?",
  "delete_scale": "Удалить шкалу",
  "delete_template": "Удалить шаблон",
  "do_not_use_emoji": "Не использовать эмодзи для этого опроса",
  "duplicate_survey": "Дублировать опрос",
  "duplicate_survey_confirm": "Вы уверены, что хотите дублировать этот опрос? Новый опрос будет создан как черновик.",
  "duplicate_template": "Дублировать шаблон",
  "duplicate_template_confirm": "Вы уверены, что хотите дублировать этот шаблон?",
  "duplicate_template_in_performance_reviews": "Дублировать в ревью",
  "duplicate_template_in_performance_reviews_confirm": "Копия этого шаблона будет создана в ревью",
  "duplicate_template_in_surveys": "Дублировать в опросы",
  "duplicate_template_in_surveys_confirm": "Копия этого шаблона будет создана в опросах",
  "edit_question": "Редактирование вопроса",
  "edit_scale": "Изменить шкалу",
  "edit_survey": "Изменить опрос",
  "element_without_emoji": "Без эмодзи",
  "file_answer_anonymous_warning_description": "Имя или содержимое файла может раскрыть вашу личность.",
  "file_answer_anonymous_warning_title": "Файл может нарушить анонимность",
  "file_upload_button": "Загрузить файлы",
  "file_upload_count_error": "Можно прикрепить не более {count} файлов",
  "file_upload_limits": "До {count} файлов размером не более {size} МБ каждый",
  "file_upload_remove": "Удалить файл",
  "file_upload_server_error": "Не удалось загрузить файл. Попробуйте ещё раз.",
  "file_upload_size_error": "Размер файла не должен превышать {size} МБ",
  "file_upload_title": "Файлы",
  "file_result_empty": "Файлы не прикреплены",
  "file_result_open_error": "Не удалось открыть файл. Попробуйте ещё раз",
  "employee_nps_breakdown": "Оценки ниже 9 требуют улучшения, 10-30 хорошие, 31-100 отличные",
  "employee_nps_element_description_default": "Оцените вероятность от 0 (точно нет) до 10 (однозначно да)",
  "employee_nps_element_title_default": "Порекомендовали бы вы нашу компанию как место работы?",
  "employee_nps_extremely_likely": "Определенно да",
  "employee_nps_not_at_all_likely": "Точно нет",
  "employee_nps_promoters": "Промоутеры",
  "employee_nps_passives": "Нейтральные",
  "employee_nps_detractors": "Критики",
  "employee_nps_score_label": "NPS {score}",
  "employee_nps_rating_excellent": "Отлично",
  "employee_nps_rating_good": "Хорошо",
  "employee_nps_rating_needs_improvement": "Требует внимания",
  "employee_nps_how_measured": "Как измеряется NPS?",
  "employee_nps_range_negative": "-100 ... -1 Требует внимания",
  "employee_nps_range_good": "0 ... 30 Хорошо",
  "employee_nps_range_excellent": "31 ... 100 Отлично",
  "employee_nps_tab_by_department": "По отделам",
  "employee_nps_tab_by_manager": "По руководителям",
  "employee_nps_tab_score_distribution": "Распределение оценок",
  "filtered_by_manager": "Отфильтровано по руководителю: {name}",
  "filtered_by_managers": "Отфильтровано по руководителям: {names}",
  "filtered_by_department": "Отфильтровано по отделу: {name}",
  "filtered_by_departments": "Отфильтровано по отделам: {names}",
  "employee_nps_results_negative_description": "Многие сотрудники не готовы рекомендовать вашу компанию",
  "employee_nps_results_negative_title": "Ваш eNPS: {score} — стоит обратить внимание",
  "employee_nps_results_neutral_description": "Сотрудники не уверены, что готовы рекомендовать вашу компанию",
  "employee_nps_results_neutral_title": "Ваш eNPS: {score} — команда настроена нейтрально",
  "employee_nps_results_positive_description": "Большинство сотрудников готовы рекомендовать вашу компанию",
  "employee_nps_results_positive_title": "Ваш eNPS: {score} — команда настроена положительно",
  "employee_surveys_empty_state_description": "Когда опросы появятся, вы увидите их здесь",
  "employee_surveys_empty_state_title": "Ещё нет опросов",
  "empty_state_scales_description": " Помогите команде давать понятные и единые оценки.\nНастройте шкалу один раз и используйте её в любых опросах.",
  "empty_state_scales_title": "Создайте первую шкалу оценок",
  "empty_state_survey_templates_description": "Шаблоны помогают быстро создавать опросы, используя готовые вопросы и настройки.\nНачните здесь, чтобы сэкономить время и следовать стандартам вашей компании.",
  "empty_state_survey_templates_title": "Создайте свой первый шаблон опроса",
  "go_to_survey": "Перейти к опросу",
  "invitation_description": "Напишите собственное письмо с приглашением участников пройти опрос.",
  "invite_co_owners_description": "Они смогут изменять опрос так же, как и вы, за исключением приглашения других совладельцев",
  "invite_co_owners_title": "Пригласить совладельцев",
  "keep_results_private_description": "Никто другой их не увидит",
  "keep_results_private_title": "Сохранить результаты приватными",
  "launch_on_schedule": "Запустить по расписанию",
  "launch_survey": "Запустить опрос",
  "make_anonymous": "Сделать анонимным",
  "manage": "Управление",
  "my_surveys": "Мои опросы",
  "no_elements_in_survey_empty_state_description": "Вы можете выбрать шкалу, текстовый ответ, выбор одного или нескольких вариантов или NPS сотрудников",
  "no_elements_in_survey_empty_state_title": "Начните с добавления первого вопроса",
  "participant_completed_label": "{count, plural, one{# Завершил} few{# Завершили} other{# Завершили}}",
  "participant_status_added": "Добавлен",
  "participant_status_canceled": "Отменен",
  "participant_status_completed": "Завершен",
  "participant_status_in_progress": "В процессе",
  "participant_status_invited": "Приглашен",
  "participants_empty_state_description": "Чтобы пригласить сотрудников, перейдите к редактированию опроса",
  "participants_empty_state_title": "Участники ещё не добавлены",
  "participants_rules_description": "Выберите, кто будет приглашен ответить на опрос.",
  "participants_waiting": "Ожидают",
  "pause_survey": "Приостановить опрос",
  "permissions_form_scales_edit_description": "Создание, редактирование и просмотр всех шкал оценок",
  "permissions_form_scales_title": "Шкалы",
  "permissions_form_scales_view_description": "Доступно для выбора существующих шкал при создании опросов",
  "permissions_survey_templates_edit_description": "Создание, изменение и управление шаблонами опросов для организации",
  "permissions_survey_templates_none_description": "Нет возможности просматривать или использовать шаблоны опросов",
  "permissions_survey_templates_title": "Шаблоны опросов",
  "permissions_survey_templates_view_description": "Просмотр существующих шаблонов без возможности внесения изменений",
  "permissions_surveys_create": "Создавать новые опросы",
  "permissions_surveys_create_description": "Разрешить опросы для сотрудников",
  "permissions_surveys_manage_all": "Управлять существующими опросами",
  "permissions_surveys_manage_all_description": "Редактировать, планировать или удалять любые опросы в системе",
  "question_comment_enabled": "Включить комментарий",
  "question_mandatory": "Обязательный вопрос",
  "question_title": "Заголовок вопроса",
  "question_type_employee_nps": "NPS сотрудников",
  "question_type_employee_nps_caption": "Оцените удовлетворенность",
  "question_type_file": "Файл",
  "question_type_file_caption": "Разрешить респондентам прикрепить файл",
  "question_type_goal": "Оценка целей",
  "question_type_goal_caption": "Оцените прогресс и уровень выполнения",
  "question_type_open_answer": "Открытый вопрос",
  "question_type_open_answer_caption": "Ответ в свободной форме",
  "question_type_page_caption": "Создать новую страницу",
  "question_type_scale": "Шкала",
  "question_type_scale_caption": "Оценка по числовой или текстовой шкале",
  "question_type_section_caption": "Добавить заголовок раздела",
  "question_type_select": "Варианты ответа",
  "question_type_select_caption": "Выберите один или несколько вариантов",
  "question_type_text": "Текст",
  "question_type_text_caption": "Добавить обычный текст",
  "question_type_text_full": "Текстовый блок",
  "reopen_survey": "Переоткрыть опрос",
  "reopen_survey_confirm": "Опрос будет переоткрыт, и сотрудники смогут продолжить участие.",
  "reopen_survey_question": "Вы хотите переоткрыть опрос?",
  "request_closed_description": "Эту заявку больше нельзя заполнить.",
  "request_closed_title": "Заявка закрыта",
  "request_fill": "Заполнить заявку",
  "request_notification_title": "Заполните заявку",
  "request_submitted_description": "Мы передали её на согласование.",
  "request_submitted_title": "Заявка отправлена",
  "responses": "Ответы",
  "responses_description": "{people_answered} на опрос. Мы показываем только полностью завершённые результаты",
  "result_not_available_yet_description": "Опрос анонимный. Чтобы сохранить конфиденциальность, результаты будут показаны, когда будет собрано достаточное количество ответов",
  "result_not_available_yet_title": "Результаты пока недоступны",
  "review_date_ends_at": "Дата окончания опроса",
  "save_as_draft": "Сохранить как черновик",
  "save_as_template": "Сохранить как шаблон",
  "scale": "Шкала",
  "scale_type_double_scale": "Двойная шкала",
  "scale_type_single_scale": "Одиночная шкала",
  "scales": "Шкалы",
  "select_scale": "Выберите шкалу",
  "select_template_description": "Используйте существующий шаблон или создайте новый для составления опроса",
  "select_template_title": "Выбрать шаблон опроса",
  "share_after_completion_description": "Выбранные люди увидят результаты только после того, как опрос будет отмечен как завершённый",
  "share_after_completion_title": "Поделиться после завершения опроса",
  "share_results": "Поделиться результатами",
  "share_specific_people_description": "Они смогут получить доступ к результатам опроса, но не смогут изменять опрос.",
  "share_specific_people_title": "Поделиться результатами с конкретными людьми",
  "start_from_scratch": "Начать с нуля",
  "start_from_scratch_confirm": "Это удалит текущую форму. Вы сможете начать с пустой или выбрать шаблон",
  "start_from_scratch_description": "Разработайте полностью новый опрос с вашими собственными вопросами",
  "start_from_scratch_title": "Создать индивидуальный опрос",
  "start_over": "Начать заново",
  "start_survey": "Начать опрос",
  "survey": "Опрос",
  "survey_history": "История опросов",
  "survey_history_empty_state_description": "Здесь будут отображаться завершенные вами опросы",
  "survey_history_empty_state_title": "История опросов пока пуста",
  "survey_status": "Статус опроса",
  "survey_closed_description": "Этот опрос больше не принимает ответы.",
  "survey_completed_description": "Ваши ответы отправлены. Спасибо за ваше участие.",
  "survey_completed_title": "Опрос завершен",
  "survey_has_been_updated_description": "Все изменения успешно сохранены",
  "survey_has_been_updated_title": "Опрос обновлён",
  "survey_share_title": "Конфиденциальность и совладельцы",
  "survey_template": "Шаблон опроса",
  "surveys": "Опросы",
  "surveys_empty_state_description": "Узнайте, что действительно важно для вашей команды.\n Задайте правильные вопросы, получите честные ответы и сделайте работу лучше для всех.",
  "surveys_empty_state_title": "Запустите свой первый опрос",
  "surveys_feature_description": "Собирайте отзывы сотрудников и измеряйте вовлеченность с помощью форм",
  "surveys_module": "Доступ к системе опросов",
  "surveys_module_description": "Необходим для всех взаимодействий с опросами.",
  "surveys_notification_description": "Новые опросы для заполнения или доступные результаты",
  "template_saved": "Шаблон сохранен",
  "use_ai_description": "Автоматически создавать выводы из ответов",
  "use_ai_title": "Использовать ИИ для анализа ответов",
  "write_to_field_all_columns": "Все колонки таблицы",
  "write_to_field_add_another": "Добавить еще",
  "write_to_field_caption": "Сохранять ответы прямо в профиль",
  "write_to_field_columns_title": "Колонки для заполнения",
  "write_to_field_destination_placeholder": "Назначение",
  "write_to_field_destination_title": "Респондент заполнит",
  "write_to_field_entry_title": "Запись {number}",
  "write_to_field_group_tables": "Таблицы",
  "write_to_field_mode_create_multiple": "Создать несколько",
  "write_to_field_mode_create_multiple_caption": "Разрешить создание нескольких записей",
  "write_to_field_mode_create_new": "Создать новую",
  "write_to_field_mode_create_new_caption": "Только одна запись",
  "write_to_field_mode_update_existing": "Обновить существующую",
  "write_to_field_mode_update_existing_caption": "Разрешить редактировать данные",
  "write_to_field_results_destination": "Ответы сохранены в профиль сотрудника → {target}",
  "write_to_field_show_current_row": "Показывать текущее значение",
  "write_to_field_show_current_row_title": "Надо ли выводить текущее значение?",
  "write_to_field_table_mode_title": "Что делать с данными?",
  "write_to_field_title": "Сохранить в поле",
  "write_to_field_view_responses_after_link": "",
  "write_to_field_view_responses_before_link": "Индивидуальные ответы доступны на вкладке",
  "~": "~"
}
